import classNames from "classnames";
import Select from "react-tailwindcss-select";
import { useEffect } from "react";
import useUpdateRouteQuery from "../../../../hooks/useUpdateRouteQuery";

const RowsPerPageSelector = ({
  totalRows,
  rowsPerPage,
  currentPath,
  onRowsPerPageChange,
  disabled,
}) => {
  const updateRouteQuery = useUpdateRouteQuery();
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const arrows = document.getElementsByClassName(
        "transition duration-300 w-6 h-6 p-0.5 transform rotate-90 text-gray-500"
      );
      for (let arrow of arrows) {
        arrow.classList.add("rotate-[-90deg]");
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  const handleRowsPerPageChange = (selected) => {
    if (onRowsPerPageChange && selected && !Array.isArray(selected)) {
      updateRouteQuery({
        query: { page: 1, rowsPerPage: selected.value },
        pathName: currentPath,
      });
      onRowsPerPageChange(Number(selected.value));
    }
  };

  return (
    <div className="items-center hidden gap-2 sm:flex">
      {/* row par page selector  */}
      <h6 className={`text-[13px] whitespace-nowrap`}>{`Rows per page:`}</h6>
      <Select
        primaryColor="#006A4E"
        value={{ label: rowsPerPage.toString(), value: rowsPerPage.toString() }}
        onChange={!disabled ? handleRowsPerPageChange : () => {}}
        isMultiple={false}
        isDisabled={!totalRows || disabled}
        classNames={{
          menuButton: (arg) =>
            classNames(
              `flex overflow-hidden pl-0.5 h-[30px] items-center justify-between text-sm font-normal bg-white  focus:text-black border border-solid border-gray-300 rounded-[4px]`,
              !arg?.isDisabled &&
                `focus:bg-white focus:border-primary focus:outline-none`,
              arg?.isDisabled && "important_disable_bg",
              arg?.isDisabled && "important_disable_bg_dark"
            ),
          menu: `absolute z-10 w-full bottom-full mb-1.5 
            bg-white text-black
          shadow-lg border rounded py-1 mt-1.5 text-sm`,
          listItem: (arg) => {
            const isSelected = arg?.isSelected; // Check if `arg` contains isSelected
            return classNames(
              "block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded",
              isSelected
                ? "text-black bg-gray-300"
                : "text-gray-500 hover:bg-gray-100"
            );
          },
        }}
        options={[
          { value: "10", label: `10` },
          { value: "20", label: `20` },
          { value: "50", label: `50` },
          { value: "100", label: `100` },
        ]}
        isClearable={false}
      />
    </div>
  );
};

export default RowsPerPageSelector;
